// js
import Adoption from '../../components/analytics/Adoption';
import { getAdoptionGoalsForCurrentArea } from '../../selectors/analytics/adoptionSelectors';
import { connect } from 'react-redux';


const mapStateToProps = (state, props) => {
  return {
    adoptionGoalsByArea: getAdoptionGoalsForCurrentArea(state, props)
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Adoption);



// WEBPACK FOOTER //
// ./src/containers/analytics/Adoption.js